import { Languages } from './types';

export const DEFAULT_LOCALE = Languages.en;

export const LS_LOCALE_KEY = 'locale';
export const LS_FORCE_LOCALE_KEY = 'force_locale';

export const TRANSLATION_IMPORT_BY_LANGUAGE: Record<
  Languages,
  () => Promise<{
    [key: string]: any;
  }>
> = {
  [Languages.en]: () => import('@/assets/i18n/en.json'),
  [Languages.ru]: () => import('@/assets/i18n/ru.json'),
};

export const DAYJS_LOCALES_IMPORT: Record<Languages, () => Promise<ILocale>> = {
  [Languages.ru]: () => import('dayjs/locale/ru'),
  [Languages.en]: () => import('dayjs/locale/en'),
};

export const UPDATE_DAYJS_LOCALE_CONFIG: Record<Languages, Record<string, unknown>> = {
  [Languages.en]: {
    calendar: {
      sameDay: '[Today at] HH:mm',
      lastDay: '[Yesterday at] HH:mm',
      lastWeek: 'D MMM [at] HH:mm',
      sameElse: 'D MMM [at] HH:mm',
    },
  },
  [Languages.ru]: {
    calendar: {
      sameDay: '[Сегодня в] HH:mm',
      lastDay: '[Вчера в] HH:mm',
      lastWeek: 'D MMM [в] HH:mm',
      sameElse: 'D MMM [в] HH:mm',
    },
  },
};
